import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import ClickableDescr from 'components/ClickableDescr'
import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import { ResizeContext } from 'contexts/Resize'
import { useSwitcher } from 'hooks/saveElementIndex'
import { H1Small as H1 } from 'styles/components/typography'

import {
  Cover,
  Content,
  IconWrapper,
  FrameWrapper,
  FrameMacStraightStyled,
  HeaderWrapper,
} from './styles'

const IMAGES = [
  'health_profile',
  'health_risks',
  'health_monogens',
  'health_related',
]

const WResultsHealth = props => {
  const { data, pathCdn } = props
  const { index, updateIndex } = useSwitcher()
  const { mobile } = React.useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={<Cover isTablet={true} />}
    >
      <div className="row">
        <div className="col-12 col-md-8">
          <Cover />
          <FrameWrapper className="py-md-4">
            <div className="position-relative py-4 py-md-0">
              <HeaderWrapper>
                <H1 as="h2" dangerouslySetInnerHTML={{ __html: data.title }} />
              </HeaderWrapper>
              <FrameMacStraightStyled
                className="d-results-health__frame"
                src={`${pathCdn}/${IMAGES[index]}`}
                alt={IMAGES[index]}
              >
                <IconWrapper className="charts">
                  <Icon id="color_charts_white" />
                </IconWrapper>
                <IconWrapper className="profile">
                  <Icon id="color_profile_new" />
                </IconWrapper>
              </FrameMacStraightStyled>
            </div>
          </FrameWrapper>
        </div>
        <div className="col-12 py-4 order-md-0 col-md-4">
          <Content>
            <ul className="list--unstyled w-100">
              {data.list.map((item, key) => (
                <ClickableDescr
                  key={key}
                  isActive={index === key}
                  noHover={mobile || data.list.length === 1}
                  onClick={() => updateIndex(key)}
                  arrowPosition="left"
                  data={{
                    title: item.title,
                    description: item.content,
                  }}
                  arrowColor={colors.white}
                />
              ))}
            </ul>
          </Content>
        </div>
      </div>
    </SectionWrapper>
  )
}

WResultsHealth.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default WResultsHealth
